import { asMultiStyleConfig } from '../../../../utils/theme';
export var ErrorBanner = asMultiStyleConfig({
  parts: ['alert', 'errorIcon', 'title', 'subtitle', 'message'],
  baseStyle: {
    alert: {
      borderRadius: 'xs',
      backgroundColor: 'none',
      border: '2px solid',
      borderColor: 'red.850'
    },
    errorIcon: {
      color: 'red.850'
    },
    title: {
      fontSize: ['lg', 'xl'],
      fontWeight: 'semibold',
      lineHeight: ['1.5rem', '2.5rem']
    },
    subtitle: {
      fontSize: ['md', 'lg'],
      fontWeight: ['bold', 'semibold'],
      lineHeight: '1.5rem'
    },
    message: {
      fontSize: ['sm', 'md'],
      lineHeight: ['1.25rem', '1.5rem']
    }
  }
});